<template>
    <b-col lg="4">
        <div class="form-item form-item-text" :class="{ 'field-error': errors.has(fieldKey) && showErrors }">
            <label :for="'user_data_' + fieldKey"
                   class="form-label">
                {{ label }}
            </label>
            <input  :id="'user_data_' + fieldKey"
                    :name="fieldKey"
                    type="text"
                    v-model="fieldValue"
                    v-validate
                    data-vv-rules="required|max:255"
                    :data-vv-as="label"
                    :disabled="sending || isVerified">
            <p class="field-error--description" v-show="errors.has(fieldKey) && showErrors">{{ errors.first(fieldKey) }}</p>
        </div>
    </b-col>
</template>

<script>
    export default {
        inject: ['$validator'],
        props: ['updateValue', 'sending', 'showErrors', 'label', 'fieldKey', 'property', 'isVerified'],
        data () {
            return {
                fieldValue: ''
            }
        },
        computed: {
            defaultValue () {
                return this.$store.getters.user[this.property]
            }
        },
        watch: {
            defaultValue () {
                this.fieldValue = this.defaultValue
            },

            fieldValue () {
                this.updateValue(this.property, this.fieldValue)
            }
        },
        mounted () {
            this.fieldValue = this.defaultValue
            this.updateValue(this.property, this.fieldValue)
        }
    }
</script>

<style lang="scss" scoped>
    label{
        &:first-letter{
            text-transform: uppercase;
         }
    }

    :disabled{
        cursor: not-allowed;
    }
</style>


// WEBPACK FOOTER //
// src/components/layout/partials/section/content/profile-edit-data/Textfield.vue